import { ButtonCancel, ButtonCreate, ButtonUpdate } from "components2"
import { Formik } from "formik"
import { Card, Modal, Nav, Tab } from "react-bootstrap"
import PermintaanPerubahanDataApi from "../api/PermintaanPerubahaDataApi"
import { ItemPerubahanDataSchema } from "../schema/ItemPerubahanDataSchema"
import { remoteFilePath } from "../utils/remoteFilePath"
import { FormItemPermintaanPerubahanData } from "./FormItemPermintaanPerubahanData"
import { ListItemPerubahanData } from "./ListItemPerubahanData"
import { TabFile } from "./TabFile"
import { TabGambar } from "./TabGambar"

export const ModalFormItemPerubahanData = ({ modal, dismissModal, onCreateItem, onUpdateItem }) => {
  const data = modal.data

  console.log(data)

  return (
    <Formik
      enableReinitialize
      initialValues={{
        kode_modul: data?.kode_modul ?? "",
        kode_menu: data?.kode_menu ?? "",
        no_referensi_transaksi: data?.no_referensi_transaksi ?? "",
        atribut: data?.atribut ?? [],
        gambar: data?.gambar ?? [],
        file: data?.file ?? []
      }}
      validationSchema={ItemPerubahanDataSchema}
      onSubmit={async (values, helpers) => {
        const v = { ...values }
        const newImage = values.gambar.filter(g => g.data)
        const newFile = values.file.filter(f => f.data)

        if (newImage.length) {
          const form = new FormData()
          newImage.forEach((item, index) => {
            form.append(`file_${index + 1}`, item.data)
          })
          const response = await PermintaanPerubahanDataApi.upload(form)
          console.log(response)
          v.gambar = [values.gambar.filter(g => !g.data), Object.values(response.data.data).map(link => ({ link: remoteFilePath(link).full }))].flat()
        }

        if (newFile.length) {
          const f = new FormData()
          newFile.forEach((item, index) => {
            f.append(`file_${index + 1}`, item.data)
          })
          const response = await PermintaanPerubahanDataApi.upload(f)
          console.log(response)
          v.file = [
            values.file.filter(f => !f.data),
            Object.values(response.data.data).map(f => ({
              nama: f?.split("/")?.pop() ?? "",
              link: remoteFilePath(f).full
            }))].flat()
        }

        if (modal.type === "CREATE") {
          onCreateItem(v, helpers)
        } else {
          onUpdateItem(v, helpers)
        }
      }}
    >
      {({ values, errors, touched, isSubmitting, setFieldValue, resetForm, handleSubmit }) => {
        const createItem = (value, resetForm) => {
          setFieldValue("atribut", [...values.atribut, value])
          resetForm()
        }

        const deleteItem = (value, index) => {
          setFieldValue("atribut", values.atribut.filter((item, i) => i !== index))
        }

        return (
          <Modal
            scrollable
            size="lg"
            show={modal.show}
            onHide={() => dismissModal(resetForm)}>
            <Modal.Header closeButton>Tambah Item Perubahan Data</Modal.Header>

            <Modal.Body>
              <FormItemPermintaanPerubahanData />

              <div className="d-flex justify-content-start align-items-center mt-4">
                <small className="font-weight-bold mr-1 ">Detail Perubahan Data</small>
                <small>
                  <span className="font-weight-bold text-danger">*mohon diisi dengan detail</span>
                </small>
              </div>

              <ListItemPerubahanData
                data={values.atribut}
                onClickCreate={createItem}
                onClickDelete={deleteItem}
              />

              <div style={{ marginTop: -15 }}>
                {errors.atribut && touched.atribut && (<small className="text-danger ">{errors.atribut}</small>)}
              </div>

              <Card className="mt-4">
                <Tab.Container defaultActiveKey="gambar">
                  <Card.Header>
                    <Nav variant="tabs">
                      <Nav.Item>
                        <Nav.Link eventKey="gambar">Gambar</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="documents">File</Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Card.Header>

                  <Card.Body>
                    <Tab.Content>
                      <Tab.Pane eventKey="gambar">
                        <TabGambar
                          type="CREATE"
                          dataGambar={values.gambar ?? []}
                        />
                      </Tab.Pane>

                      <Tab.Pane eventKey="documents">
                        <TabFile
                          dataFile={values.file ?? []}
                          type="CREATE" />
                      </Tab.Pane>
                    </Tab.Content>
                  </Card.Body>
                </Tab.Container>
              </Card>
            </Modal.Body>

            <Modal.Footer>
              <div className="d-flex justify-content-center">
                <ButtonCancel
                  className="mr-2"
                  disabled={isSubmitting}
                  onClick={() => dismissModal(resetForm)}
                />

                {modal.type === "CREATE" ? (
                  <ButtonCreate
                    loading={isSubmitting}
                    onClick={() => handleSubmit()}
                  />
                ) : (
                  <ButtonUpdate
                    loading={isSubmitting}
                    onClick={() => handleSubmit()}
                  />
                )}
              </div>
            </Modal.Footer>
          </Modal>
        )
      }}
    </Formik >
  )
}